/* eslint-disable no-template-curly-in-string */
import { RuleType } from "pages/Rules/common/types";

import { Content, LinkFormat } from "@dashboard-v3/api";
import { ParsedContent } from "./types";

export const isAttachment = (ruleType: RuleType) => {
  return (
    ruleType === "PROTECT_EMAILS" ||
    ruleType === "REPLACE_ATTACHMENTS" ||
    ruleType === "ZIP_ATTACHMENTS"
  );
};

export const isEmailType = (val: Content["type"]) => {
  return val === "EML" || val === "MSG" || val === "ORIGINAL";
};

export const containsEmailType = (contents: Content[]) => {
  return contents.some(content => isEmailType(content.type));
};

export const getParsedContent = (content: Content[]): ParsedContent =>
  content.reduce((acc, item) => {
    if (item.type === "EML" || item.type === "MSG") {
      return { ...acc, email: item };
    }
    if (item.type === "ATTACHMENTS") {
      return { ...acc, attachments: item };
    }
    if (item.type === "PDF") {
      return { ...acc, pdf: item };
    }
    return acc;
  }, {});

export const getContentErrors = (selected: Content["type"][] = []) => {
  return new Map([
    ["EMPTY", !selected.length],
    [
      "PROTECT_EMAILS",
      !selected.includes("ATTACHMENTS") || !selected.includes("PDF"),
    ],
    ["REPLACE_ATTACHMENTS", !selected.includes("ATTACHMENTS")],
  ]);
};

export const nameFormatDefaults = (val: Content["type"]) => {
  return val === "ATTACHMENTS"
    ? "{attachments_name}"
    : "{sent_or_received_date_yyyyMMdd_HHmm}-{subject_normalized}";
};

export const mapLinkFormat = (
  linkFormat: LinkFormat[]
): "PDF" | "LINK" | "BOTH" => {
  if ((linkFormat || []).length === 0) return "PDF";
  if (linkFormat.length === 1) return linkFormat[0];
  return "BOTH";
};

export const filtersByContentByType = {
  email: (item: Content) => item.type === "EML" || item.type === "MSG",
  attachments: (item: Content) => item.type === "ATTACHMENTS",
  pdf: (item: Content) => item.type === "PDF",
};
